import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { AuthShell, Field, inputClass } from "@/pages/auth/authShared";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset — please log in.");
      navigate("/login", { replace: true });
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || "Reset failed");
    } finally { setLoading(false); }
  };

  if (!token) return <AuthShell title="Invalid link"><p className="text-center text-[#5C4A42]">This reset link is missing or invalid. <Link to="/forgot-password" className="font-semibold text-[#B04B26] underline">Request a new one</Link>.</p></AuthShell>;

  return (
    <AuthShell title="Choose a new password" footer={<Link to="/login" className="font-semibold text-[#B04B26] hover:underline">← Back to log in</Link>}>
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <Field label="New password" error={password && password.length < 8 ? "At least 8 characters" : ""}>
          <input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} className={inputClass} data-testid="reset-password" autoComplete="new-password" />
        </Field>
        {error && <p className="rounded-lg bg-[#FEF2F2] px-3 py-2 text-sm font-semibold text-[#991B1B]" data-testid="reset-error">{error}</p>}
        <button type="submit" disabled={loading} data-testid="reset-submit" className="w-full rounded-xl bg-[#C85A32] px-4 py-3 font-bold text-white hover:bg-[#B04B26] disabled:opacity-60">{loading ? "Saving…" : "Reset password"}</button>
      </form>
    </AuthShell>
  );
}
